export const variables = {
  // API_URL: "https://apigazelle.vision-more.com/api/",
  // PHOTO_URL: "https://apigazelle.vision-more.com/Uploads/",

  API_URL: "https://api.gazellebyrasha.com/api/",
  PHOTO_URL: "https://api.gazellebyrasha.com/Uploads/",
};
